import { useEffect } from 'react';

/**
 * Toggles global search on Meta/Ctrl+K.
 * Always toggles (including while focused in inputs) so staff can interrupt typing.
 */
export function useGlobalSearchHotkey(
  open: boolean,
  onOpenChange: (open: boolean) => void,
): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        onOpenChange(!open);
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onOpenChange]);
}

/** Platform-aware shortcut label for the header kbd chip. */
export function getSearchShortcutLabel(): string {
  if (typeof navigator === 'undefined') return 'Ctrl K';
  const platform =
    'userAgentData' in navigator &&
    typeof (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData
      ?.platform === 'string'
      ? (navigator as Navigator & { userAgentData: { platform: string } }).userAgentData.platform
      : navigator.platform;
  return /mac|iphone|ipad|ipod/i.test(platform) ? '⌘K' : 'Ctrl K';
}
